import React from "react";
import { useTranslation } from "react-i18next";
import useMediaQuery from "../../utils/hooks/use-media-query";
import "./mobile-modal-frame.scss";

/** Custom dialogs lack Bootstrap's separate header/body. Keep their desktop DOM intact. */
export default function MobileModalFrame({ children, onClose }: { children: React.ReactNode; onClose?: () => void }) {
  const mobile = useMediaQuery("(max-width: 991.98px)");
  const { t, i18n } = useTranslation("common");
  if (!mobile) return <>{children}</>;
  return <div className="mobile-modal-frame" dir={i18n.dir()}>
    <div className="mobile-modal-frame__header">
      <button type="button" onClick={onClose} disabled={!onClose} aria-label={t("Close dialog")}>×</button>
    </div>
    <div className="mobile-modal-frame__body">{children}</div>
  </div>;
}
